import { render, staticRenderFns } from "./holddollar-detail.vue?vue&type=template&id=eaa6ed24&scoped=true&"
import script from "./holddollar-detail.vue?vue&type=script&lang=js&"
export * from "./holddollar-detail.vue?vue&type=script&lang=js&"
import style0 from "./holddollar-detail.vue?vue&type=style&index=0&id=eaa6ed24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaa6ed24",
  null
  
)

export default component.exports